export const shouldShowParentPortalSwitch = ({ hasParentRole, variant }) =>
  Boolean(hasParentRole) && variant !== "parent";
